import { Box, Button, Icon } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { BiCreditCard, BiLinkExternal, BiMoney, BiSolidMinusCircle } from "react-icons/bi";
import { MdPointOfSale } from "react-icons/md";
import { MdPix } from "react-icons/md";

const pulse = keyframes`
0% { transform: scale(1); }
50% { transform: scale(1.1); }
100% { transform: scale(1); }
`;

const spinAnimation = `${pulse} infinite 2s linear`; 

interface Props {
  handleCancel: () => void;
  handleDinheiro: () => void;
  handlePix: () => void;
  handleCartao: () => void;
  isDevolucao?: boolean;
  handleLinkPagamento?: () => void;
  handlePos?: () => void;
  showDinheiro?: boolean;
  showPix?: boolean;
  showCartao?: boolean;
  showLinkPagamento?: boolean;
  showPos?: boolean;
  showCancel?: boolean;
  isPaymentDisabled?: boolean;
  paymentDisabledReason?: string;
  isCancelDisabled?: boolean;
  selectedPaymentMethod?: string | number | null;
}

export function Actions({
  handleCancel,
  handleDinheiro,
  handlePix,
  handleCartao,
  handleLinkPagamento,
  handlePos,
  showDinheiro = true,
  showPix = true,
  showCartao = true,
  showLinkPagamento = false,
  showPos = false,
  isDevolucao = false,
  showCancel = true,
  isPaymentDisabled = false,
  paymentDisabledReason,
  isCancelDisabled = false,
  selectedPaymentMethod = null,
}: Props) {
  const disabledTitle = isPaymentDisabled ? paymentDisabledReason : undefined;
  const selectedPayment = selectedPaymentMethod === null || selectedPaymentMethod === undefined
    ? null
    : String(selectedPaymentMethod).toLowerCase();
  const canShowPayment = (method: string, code: number) => selectedPayment === null
    || selectedPayment === method
    || selectedPayment === String(code);

  return (
    <Box
      width={"100%"}
      bg={"#f4f4f4"}
      p={"2"}
      display={"flex"}
      flexDir={{ sm: "column", md: "row" }}
      gap={{ sm: 2, md: 8 }}
      alignItems={'center'}
      justifyContent={"center"}
    >
      {canShowPayment('pix', 3) && showPix && (
        <Button
          onClick={handlePix}
          isDisabled={isPaymentDisabled}
          title={disabledTitle}
          bg={"purple.300"}
          borderWidth={'1px'}
          borderColor={'purple.500'}
          color={"black"}
          borderRadius={"none"}
          minW={"162px"}
          rightIcon={<Icon as={MdPix} boxSize={'24px'} animation={spinAnimation}/>}
        >
          PIX
        </Button>
      )}
      {canShowPayment('dinheiro', 1) && showDinheiro && (
        <Button
          onClick={handleDinheiro}
          isDisabled={isPaymentDisabled}
          title={disabledTitle}
          bg={"#92d050"}
          color={"white"}
          borderRadius={"none"}
          rightIcon={<BiMoney size={"24"} />}
        >
          Pagamento Dinheiro
        </Button>
      )}
      {canShowPayment('cartao', 2) && showCartao && (
        <Button
          onClick={handleCartao}
          isDisabled={isPaymentDisabled}
          title={disabledTitle}
          bg={"#ffff00"}
          color={"black"}
          borderRadius={"none"}
          rightIcon={<BiCreditCard size={"24"} />}
        >
          Cartão de Crédito
        </Button>
      )}
      {canShowPayment('link', 4) && showLinkPagamento && handleLinkPagamento && (
        <Button
          onClick={handleLinkPagamento}
          isDisabled={isPaymentDisabled}
          title={disabledTitle}
          bg={"#0ea5e9"}
          color={"white"}
          borderRadius={"none"}
          rightIcon={<BiLinkExternal size={"24"} />}
        >
          Link de Pagamento
        </Button>
      )}
      {canShowPayment('pos', 5) && showPos && handlePos && (
        <Button
          onClick={handlePos}
          isDisabled={isPaymentDisabled}
          title={disabledTitle}
          bg={"#334155"}
          color={"white"}
          borderRadius={"none"}
          rightIcon={<MdPointOfSale size={"24"} />}
        >
          Pagamento POS
        </Button>
      )}
      {showCancel && (
        <Button
          onClick={handleCancel}
          isDisabled={isCancelDisabled}
          title={isCancelDisabled ? paymentDisabledReason : undefined}
          bg={"#ff0000"}
          color={"white"}
          borderRadius={"none"}
          rightIcon={<BiSolidMinusCircle size={"24"} />}
        >
          {isDevolucao ? 'Devolver Pedido' : 'Cancelar Pedido'}
        </Button>
      )}
    </Box>
  );
}
